import React, { useState } from "react";
import { TextField, Button } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";

const MatchSetup = ({ formData, setFormData }) => {
    const [bulkStartDate, setBulkStartDate] = useState(dayjs());
    const [bulkEndDate, setBulkEndDate] = useState(dayjs());
    const bulkFrequency = "weekly";

    const handleMatchDateChange = (index, date) => {
        const newMatches = [...formData.matches];
        newMatches[index] = { date: date ? date.toDate() : null };
        setFormData((prev) => ({ ...prev, matches: newMatches }));
    };

    const addMatch = () => {
        setFormData((prev) => ({ ...prev, matches: [...prev.matches, { date: new Date() }] }));
    };

    const removeMatch = (index) => {
        setFormData((prev) => ({ ...prev, matches: prev.matches.filter((_, i) => i !== index) }));
    };

    const handleBulkCreate = () => {
        const newMatches = [];
        let currentDate = dayjs(bulkStartDate);

        while (currentDate.isBefore(bulkEndDate) || currentDate.isSame(bulkEndDate, "day")) {
            newMatches.push({ date: currentDate.toDate() });
            currentDate = currentDate.add(bulkFrequency === "weekly" ? 7 : 14, "day");
        }

        setFormData((prev) => ({ ...prev, matches: [...prev.matches, ...newMatches] }));
    };

    return (
        <div className="form-container">
            <h2>Match Setup</h2>
            {formData.matches.map((match, index) => (
                <div key={index} className="match-entry">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                            label="Match Date"
                            value={match.date ? dayjs(match.date) : null}
                            onChange={(date) => handleMatchDateChange(index, date)}
                            renderInput={(params) => <TextField {...params} className="styled-select" />}
                        />
                    </LocalizationProvider>
                    <Button onClick={() => removeMatch(index)} variant={'contained'}>Remove</Button>
                </div>
            ))}
            <Button onClick={addMatch} variant={'contained'}>Add Match</Button>
            <h3>Bulk Match Creation</h3>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                    label="Bulk Start Date"
                    value={bulkStartDate}
                    onChange={setBulkStartDate}
                    renderInput={(params) => <TextField {...params} className="styled-select" />}
                />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                    label="Bulk End Date"
                    value={bulkEndDate}
                    onChange={setBulkEndDate}
                    renderInput={(params) => <TextField {...params} className="styled-select" />}
                />
            </LocalizationProvider>
            <Button onClick={handleBulkCreate} variant={'contained'}>Generate Matches</Button>
        </div>
    );
};

export default MatchSetup;